<template>
  <!-- prikaz stranice liste oglasa (pages/oglasi/**/[page].vue): pretraga, h1, lista ili poruka da nema oglasa -->
  <div v-if="loaded">
    <AdSearch />

    <div class="shadow rounded p-element-page bg-white mb-2">
      <h1 class="h1-title">{{ h1 }}</h1>
      <hr />
      <p v-if="empty" class="mb-0 text-muted">Trenutno nema oglasa u ovoj kategoriji ili mestu.</p>
    </div>

    <DisplayPublicPage :items="items" />
  </div>
</template>

<script setup>
import AdSearch from '~/components/search/AdSearch.vue'
import DisplayPublicPage from '~/components/cmsCustomer/advertisement/display/DisplayPublicPage'

defineProps({
  loaded: { type: Boolean, default: false },
  empty: { type: Boolean, default: false },
  h1: { type: String, default: '' },
  items: { type: Array, default: () => [] },
})
</script>
